import React, { useState, MouseEvent, ChangeEvent, useEffect } from 'react'
import parse from 'html-react-parser'
import Page from '../types/Page'
import Item, { ItemLevel1, ItemLevel2 } from '../types/Item'
import Level2LayoutProps from '../types/Level2LayoutProps'
import Event from '../../events/types/Event'

const NUM_EVENTS = 4
const IS_GOOGLE_TRANSLATE = !!window.location.host.match('bpl-bc-ca.translate.goog')

export default ({ ...props }: Level2LayoutProps) => {
  const soon = props.events.filter(e => e.group === "soon").sort((a: Event, b: Event): number => {
    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
  }).reverse()
  soon.length = soon.length > 4 ? NUM_EVENTS : soon.length

  const ongoing = props.events.filter(e => e.group === "ongoing").sort((a: Event, b: Event): number => {
    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
  }).reverse()
  ongoing.length = ongoing.length > 4 ? NUM_EVENTS : ongoing.length

  return (
    <div className={'level-2'} id={props.level1active.slug}>
      {/*<div className="close-button" onClick={props.handleClose}>Close</div>*/}
      <div className={'switchboard switchboard-events'}>
        {ongoing.length > 0 && (
          <div className="left-column">
            <span className="events-section-title">Happening Today</span>
            {ongoing.map(e => (
              <a href={IS_GOOGLE_TRANSLATE && e.url.indexOf('https://bpl.bc.ca') > -1 ? window.location.origin + e.url.replace('https://bpl.bc.ca', '') + window.location.search : e.url} className="menu-event">
                <span>{e.title}</span>
                <p>{dateFormat(e.startDate)} <strong>{e.startTime}</strong></p>
              </a>
            ))}
          </div>
        )}
        <div className="left-column">
          <span className="events-section-title">Happening Soon</span>
          {soon.map(e => (
            <a href={IS_GOOGLE_TRANSLATE && e.url.indexOf('https://bpl.bc.ca') > -1 ? window.location.origin + e.url.replace('https://bpl.bc.ca', '') + window.location.search : e.url} className="menu-event">
              <span>{e.title}</span>
              <p>{dateFormat(e.startDate)} <strong>{e.startTime}</strong></p>
            </a>
          ))}
        </div>
      </div>
      <div className="switchboard switchboard-events">
        <div className="left-column">
          <p><a href="/events" className="all-events">All Upcoming Events</a></p>
        </div>
        <div className="right-column">
          <p className="event-search">Can't find an event? <a href={IS_GOOGLE_TRANSLATE ? window.location.origin + "/events" + window.location.search : "/events"}>Try a Search</a></p>
        </div>
      </div>
    </div>
  )
}

const dateFormat = (date: string): string => {
  // Add timezone offset so we get back to midnight, otherwise we can be a day behind later in the day.
  return `${new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(new Date((new Date(date)).getTime() + (new Date(date)).getTimezoneOffset() * 60 * 1000))}`
}

